import React, { useState, useEffect, createRef } from 'react';
import styled from 'styled-components';
import { Icon } from '@zebra-fed/zds-react-desktop';
import TextField from '@material-ui/core/TextField';
import '@zebra-fed/icons/General/index.css';
import { useTranslation } from "react-i18next";
import RefreshIcon from '@material-ui/icons/Refresh';

const RefreshIconStyled = styled(RefreshIcon)`
    fill: #0073E6 !important;
    margin-right: 20px;
    border-style:solid;
    border-radius: 4px;
    border-width: thin;
    padding:4px;
    border-color: #0073E6;
    &:hover {
        cursor: pointer;
    }
`;

const ToolbarWrapper = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    position: absolute;
    z-index: 999;
    margin-right: auto;
    left: 0;
    right: 0;
    top: -60px;
    display: flex;
    flex-direction: row;
    align-items: end;
    width: fit-content;
    right: 0;
    left: auto;
    padding: 5px;
    border-radius: 4px;
    margin-right: 0;
    margin-left: auto;
    @media screen and (max-width: 750px) {
        right: auto;
        padding-left: 0;
        margin-top: 10px;
        width: 100%;
        justify-content: space-between;
    }
`

export default function Toolbar(props) {
    const { multiSearchOpts = [], onRefreshClick } = props;
    const [searchVal, setSearchVal] = useState('');
    console.log('searchVal :', searchVal);
    const [isError, setIsError] = useState(false)
    const { t } = useTranslation();
    const [openSearchBox, setOpenSearchBox] = useState(false)
    const [searchOptVal, setSearchOptVal] = useState('')
    const radioRef = createRef();
    const [searchInputError, setSearchInputError] = useState("")
    const [searchOptError, setSearchOptError] = useState("")
    console.log('searchOptVal :', searchOptVal);

    useEffect(() => {
        setSearchVal(props.searchText)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function onChangeSearchBox(e) {
        let value = e.target.value;
        // let regexVal = value.replace(/[^a-zA-Z0-9.,_#$[\]\\]/gi, '');
        let regexVal = value.replace(/[^-?a-zA-Z0-9_:;+=<>?'"!@%^&*(){}|\//\s]/gi, '');
        // setSearchVal(e.target.value.trim());
        setSearchVal(regexVal);
        setSearchInputError("")
        if (e.target.value === "") {
            props.onClear(searchVal);
        }
    }


    return (
        <ToolbarWrapper>
            <RefreshIconStyled onClick={onRefreshClick} />
            <TextField
                error={isError}
                helperText={isError ? t('searchSiteName') : ""} //"Please enter a valid email id to search."
                style={{}}
                placeholder={t('searchSiteName')}
                value={searchVal}
                onFocus={() => setOpenSearchBox(true)}
                onChange={(e) => {
                    onChangeSearchBox(e)
                }}
                onKeyDownCapture={multiSearchOpts.length === 0 ? (e) => {
                    if (e.keyCode === 13) {
                        if (e.target.value.trim() === "")
                            setIsError(true)

                        props.onSearch(searchVal)
                    }
                } : false}
                InputProps={{
                    startAdornment:
                        <Icon
                            category={'general'}
                            name={'search'}
                            size={15}
                            style={{ cursor: 'pointer', padding: '0 8px 4px 0' }}
                            color={'#bdbdbd'}
                        />,
                    endAdornment:
                        <Icon
                            category={'navigation'}
                            name={'close'}
                            size={15}
                            style={{
                                cursor: 'pointer', paddingRight: '4px',
                                visibility: searchVal === '' ? 'hidden' : 'visible'
                            }}

                            color={'#bdbdbd'}
                            onClick={() => {
                                if (searchVal) {
                                    setSearchVal('')
                                    props.onClear(searchVal)
                                }
                            }}
                        />,
                }}
            />            
        </ToolbarWrapper>
    )
}